// Batch 134 — the one place the legal documents' revision date lives.
//
// A CONSTANT, NEVER new Date(). Landing.jsx renders `new Date().getFullYear()`
// in its copyright line, which is right there and WRONG here: a live clock in
// a legal document would silently claim the policy was revised today, every
// day, to every reader. This changes only when the text changes.
//
// It is transcribed from the "**Last updated:**" line in privacy.md and
// terms.md, which are the source of record. legalPages.test.js asserts both
// documents agree with each other and that this constant matches them, so the
// three cannot drift.
export const LAST_UPDATED = "15 August 2026";

// The operator's contact address, as stated in both documents. Kept here so a
// change lands in one place rather than in two pages and a footer.
export const CONTACT_EMAIL = "sparkcue0@gmail.com";
